import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import useUser from '../../hooks/useUser'
import { getBasePath, getAuth, getPermisosEnPagina, permisoAdecuado, getImagenBasePath, toastAlert } from '../../Utils'
import axios from "axios"
import Select from 'react-select'
import { Input, Form } from 'reactstrap'
import Swal from 'sweetalert2'
import SinPermisos from '../SinPermisos'

const Empresasform = () => {
    const navigate = useNavigate();
    const {isLogged, permisosUsuario} = useUser();
    const permisos = getPermisosEnPagina(permisosUsuario, 'Empresas')
    const datos = useParams() //Obtenemos los parámetros pasados por url { accion: "edit", id: "1" }
    const [nombre, setNombre] = useState('')
    const [descripcion, setDescripcion] = useState('')
    const [telefono, setTelefono] = useState('')
    const [nombreContacto, setNombreContacto] = useState('')
    const [razonSocial, setRazonSocial] = useState('')
    const [tipoCifNif, setTipoCifNif]  = useState('')
    const [cifNif, setCifNif]  = useState('')
    const [imagen, setImagen]  = useState('')
    const [newImagen, setNewImagen] = useState('')
    const [numCuenta, setNumCuenta] = useState('')
    const [pie1, setPie1] = useState('')
    const [pie2, setPie2] = useState('')
    const [plantilla, setPlantilla] = useState(null)
    const [tab, setTab] = useState("empresa");

    useEffect(() => {
        if (!isLogged) { navigate("/login"); }
    }, [isLogged]);

    const options = [
        { value: 'Cif', label: 'Cif' },
        { value: 'Nif', label: 'Nif' },
        { value: 'DNI', label: 'DNI' },
        { value: 'Pasaporte', label: 'Pasaporte' }
      ]

      const getPlantillasOptions = () => {
        const optionsPlantillas = [
            { value: 'Plantilla 1', label: 'Plantilla 1' },
            { value: 'Plantilla 2', label: 'Plantilla 2' },
            { value: 'Plantilla 3', label: 'Plantilla 3' }
        ]
        return optionsPlantillas
    }


    const getDatosEmpresa = async () => {
        try {
            const {data: empresa} = await axios.get(`${getBasePath()}/empresas/${datos.id}`, getAuth());
            setNombre(empresa.nombre)
            setDescripcion(empresa.descripcion)
            setRazonSocial(empresa.razonSocial)
            setTelefono(empresa.telefono)
            setNombreContacto(empresa.nombreContacto)
            setTipoCifNif(empresa.tipoCifNif)
            setCifNif(empresa.cifnif)
            setImagen(empresa.imagen)
            setNumCuenta(empresa.numCuenta)
            setPie1(empresa.pie1)
            setPie2(empresa.pie2)
            setPlantilla(empresa.plantilla)
        } catch (error) {
            console.error(error)
            Swal.fire({
                title: 'Error',
                text: 'Empresa no encontrada',
                icon: 'error'
              })
        }
    }

    const submitEmpresa = async (empresaObj) => {
        try {
            if (datos.accion === 'nuevo') 
                await axios.post(`${getBasePath()}/empresas`, empresaObj, getAuth());
            if (datos.accion === 'editar') 
                await axios.put(`${getBasePath()}/empresas/${datos.id}`, empresaObj, getAuth());
            toastAlert('Empresas')
            navigate("/empresas")
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: 'Error en la creación de la empresa',
                icon: 'error'
              })
            console.error(error)
        }
    }

    const handleImageChange = (e) => {
        const reader = new FileReader()
        reader.onload = function (e) {
            setImagen(e.target.result)
            setNewImagen(e.target.result)
        }
        reader.readAsDataURL(e.target.files[0])
    }

    useEffect(() => {
        if(datos.accion !== 'nuevo') { getDatosEmpresa() }
    }, [])

    function handleSubmit (e) {
        e.preventDefault()
        const empresaObj = {
            nombre,
            descripcion,
            telefono,
            nombreContacto,
            razonSocial,
            tipoCifNif,
            cifNif,
            imagen,
            numCuenta,
            pie1,
            pie2,
            plantilla
        }
        console.log(pie1)
        submitEmpresa(empresaObj)
    }

    return isLogged && permisoAdecuado(permisos, datos.accion) ? (
        <div className="row gap-20 " style={{ position:"relative",height:"1116px" }} >
            <div className="masonry-item col-md-12" style={{ position:"absolute", left:"0%", top:"0px" }} >
                <div className="bgc-white p-20 bd">
                    <div className="mT-30">
                        <Form onSubmit={handleSubmit}>
                            <div style={{paddingBottom:'20px'}}>
                                <input type="hidden" id="imagen_antigua" value={imagen} />
                                <div className='row'>
                                    <div className="mb-3 col-md-4">
                                        <img id="imagen" 
                                            className='user-avatar rounded mr-2 my-25 cursor-pointer'
                                            src={newImagen || `${getImagenBasePath()}/${imagen}`}
                                            alt='Imagen empresa'
                                            height='90px'
                                            width='90px'
                                        />
                                        <label className="form-label">Imagen</label>
                                        <Input 
                                            type="file" 
                                            className="form-control" 
                                            onChange={(e) => handleImageChange(e)} 
                                            disabled={datos.accion === 'ver'}
                                        />
                                    </div>
                                </div>
                            </div>
                            <ul className="nav nav-tabs">
                                <li className="nav-item">
                                    <a className={tab == "empresa" ? 'nav-link active' : 'nav-link'} href="#" onClick={() => setTab('empresa')}>Datos Empresa</a>
                                </li>
                                <li className="nav-item">
                                    <a className={tab == "facturacion" ? 'nav-link active' : 'nav-link'} href="#" onClick={() => setTab('facturacion')}>Datos Facturación</a>
                                </li>
                            </ul>
                            <div style={{paddingBottom:"20px", paddingTop:"20px"}}>
                                <div style={{ display: tab === "empresa" ? "block" : "none" }}>
                                    <div className='row'>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Nombre *</label>
                                            <Input type="text" className="form-control" id="nombre" aria-describedby="nombre" defaultValue={nombre} onChange={({target}) => setNombre(target.value)} disabled={datos.accion === 'ver'} required/>
                                        </div>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Descripción</label>
                                            <Input type="text" className="form-control" id="descripcion" aria-describedby="descripcion" defaultValue={descripcion} onChange={({target}) => setDescripcion(target.value)} disabled={datos.accion === 'ver'}/>
                                        </div>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Teléfono</label>
                                            <Input type="text" className="form-control" id="telefono" aria-describedby="telefono" defaultValue={telefono} onChange={({target}) => setTelefono(target.value)} disabled={datos.accion === 'ver'}/>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Nombre de Contacto</label>
                                            <Input type="text" className="form-control" id="nombreContacto" aria-describedby="nombreContacto" defaultValue={nombreContacto} onChange={({target}) => setNombreContacto(target.value)} disabled={datos.accion === 'ver'}/>
                                        </div>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Razón Social</label>
                                            <Input type="text" className="form-control" id="razonSocial" aria-describedby="razonSocial" defaultValue={razonSocial} onChange={({target}) => setRazonSocial(target.value)} disabled={datos.accion === 'ver'}/>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">CifNif</label>
                                            <Select 
                                                options={options} 
                                                id="tipoCifNif"
                                                value={options.find(el => el.value === tipoCifNif)}
                                                onChange={(target) => setTipoCifNif(target.value)}
                                                isDisabled={datos.accion === 'ver'}
                                            />
                                        </div>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Documento</label>
                                            <Input type="text" className="form-control" id="cifnif" aria-describedby="cifnif" value={cifNif} onChange={({target}) => setCifNif(target.value)} disabled={datos.accion === 'ver'}/>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: tab === "facturacion" ? "block" : "none" }}>
                                    <div className='row'>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Plantilla </label>
                                            <Select 
                                                value={getPlantillasOptions().find(el => el.value == plantilla)}
                                                options={getPlantillasOptions()} 
                                                onChange={(target) => setPlantilla(target.value)}
                                                isDisabled={datos.accion === 'ver'}
                                            />
                                        </div>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Número de cuenta</label>
                                            <Input type="text" className="form-control" id="numCuenta" aria-describedby="numCuenta" defaultValue={numCuenta} onChange={({target}) => setNumCuenta(target.value)} disabled={datos.accion === 'ver'}/>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="mb-9 col-md-12">
                                            <label className="form-label">Pie 1</label>
                                            <textarea className="form-control" id="pie1" aria-describedby="pie1" onChange={({target}) => setPie1(target.value)} disabled={datos.accion === 'ver'} defaultValue={pie1}></textarea>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="mb-9 col-md-12">
                                            <label className="form-label">Pie 2</label>
                                            <textarea className="form-control" id="pie2" aria-describedby="pie2" onChange={({target}) => setPie2(target.value)} disabled={datos.accion === 'ver'} defaultValue={pie2}></textarea>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex'>
                                <button type="submit" className="btn btn-primary btn-color" disabled={datos.accion === 'ver'}>Guardar</button>
                                <Link className="btn btn-secondary btn-color" to="/empresas" style={{marginLeft: '10px'}}>Atras</Link>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    ): (<SinPermisos/>)
}

export default Empresasform


